import React, { type FC } from 'react';

export interface HeaderProps {
  text: string;
}

const outerDivStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '14px',
  textAlign: 'center',
  clear: 'both',
  paddingTop: '10px',
  paddingBottom: '3px',
  color: '#8AA',
};

export const Header: FC<HeaderProps> = ({ text }) => {
  return <div style={outerDivStyle}>{text}</div>;
};
